module.exports = `${require.publicPath}NotoSansSC-Bold.4d7d6fee.woff`;